import { render, staticRenderFns } from "./BaseAbout.vue?vue&type=template&id=f2acedc6&scoped=true&"
import script from "./BaseAbout.vue?vue&type=script&lang=js&"
export * from "./BaseAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2acedc6",
  null
  
)

export default component.exports